import React from "react";
import {Button, Input, Popover, Table} from "antd";
import {AddWasteProfile} from "./AddWasteProfile";
import {TrackHeaderLink} from "../TrackHeaderLink";
import {WasteProfileList, WasteProfilePDF} from "../../../models/waste_profile/wasteProfile";


const Search = Input.Search;
const _ = require('lodash');
const moment = require('moment');

export class WasteProfile extends React.Component {
    state = {
        AddWasteProfile: false,
        loading: false,
        data: [],
        editId:null,
    };

    fetchWasteProfile = (params = {}, reset = false) => {
        if (!reset)
            params = {...this.state.params, ...params};
        this.setState({loading: true, params});
        WasteProfileList(params)
            .then(response => {
                const pagination = {...this.state.pagination};
                pagination.total = response.data.count;
                this.setState({
                    loading: false,
                    data: response.data.results,
                    pagination,
                });
            });
    };

    printDetailPDF = (id) => {
        WasteProfilePDF(id);
    };
    editWasteProfile = (id) => {
        this.setState({AddWasteProfile: true, editId: id})
    }

     showAddWasteProfile = (visible) => {
        this.setState({AddWasteProfile: visible,editId: null})
    }

    componentDidMount() {
        this.fetchWasteProfile();
    }
    columns = [
        {
            title: 'Action',
            render: item =>
                <Popover placement="right" content={
                    <div className="action-column action-dropdown">
                        <a title="View" key={"view"}><i className="fa fa-eye"/></a>
                        <a title="Edit" key={'edit'} onClick={() => this.editWasteProfile(item.id)}><i className="fa fa-pencil"/></a>
                        <a title="Print" onClick={() => this.printDetailPDF(item.id)} key={'print'}><i className="icon-printer"/></a>
                    </div>
                } trigger="hover">
                    <a className="action-dropdown" href="#"><i className="fa fa-ellipsis-h"/> </a>
                </Popover>,
            key: 'action'
        }, {
            title: "Date Created",
            dataIndex: 'created',
            key: 'created',
            render: created => moment(created).format('YYYY-MM-DD')
        },  {
            title: "Generator",
            dataIndex: 'generator.label',
            key: 'generator'
        },  {
            title: "Bill To",
            dataIndex: 'bill_to.label',
            key: 'bill_to'
        },  {
            title: <span>Waste <br/> Stream</span>,
            dataIndex: 'waste_stream.label',
            key: 'waste_stream'
        }, {
            title: <span>Process <br/> Description</span>,
            dataIndex: 'process_description',
            key: 'process_description'
        }, {
            title: 'Color',
            dataIndex: 'physical_prop.color',
            key: 'color'

        }, {
            title: 'Oil',
            dataIndex: 'physical_prop.oil',
            key: 'oil'

        }, {
            title: 'Solids',
            dataIndex: 'physical_prop.solids',
            key: 'solids'

        }, {
            title: 'Water',
            dataIndex: 'physical_prop.water',
            key: 'water'

        }, {
            title: 'Layered',
            dataIndex: 'physical_prop.layered',
            render: layered => layered ? "Yes" : "No",
            key: 'layered'

        }, {
            title: <span>Flash  Point <br/> (Actual)</span>,
            dataIndex: 'flash_point',
            key: 'flash_point'

        }, {
            title: 'pH',
            dataIndex: 'ph',
            key: 'ph'

        }, {
            title: <span>Total <br/> Halogen</span>,
            dataIndex: 'total_halogen',
            key: 'total_halogen'

        }, {
            title: 'PCB',
            dataIndex: 'pcb',
            key: 'pcb',
            render: pcb => pcb ? "Yes" : "No"
        },];


    render() {
        const {visible} = this.props;
        const {data, loading,editId} = this.state;

        return (
            <div id="main-content">
                <div className="container-fluid">
                    <div className="block-header">
                        <div className="row clearfix">
                            <div className="col-sm-2 col-12">
                                <h3 className="main-heading">AB Tracks</h3>
                            </div>
                            <div className="col-sm-10 col-12">
                                <TrackHeaderLink/>
                            </div>
                        </div>
                        <div className="row clearfix edit-header">
                            <div className="col-sm-6 col-12">
                                <Search placeholder="Input search text" style={{width: "100%", height: "38px"}}/>
                            </div>
                            <div className="col-sm-2 col-12">
                                <div id="date_range_wrapper">
                                    <Button type="primary" onClick={() => this.showAddWasteProfile(true)}
                                            className="submit-btn h-auto xs-hide">Create Waste Profile</Button>
                                    <button className="btn submit-btn xs-show" type="button" onClick={() => this.showAddWasteProfile(true)}>
                                        <i className="fa fa-plus" /></button>
                                </div>
                            </div>
                            <div className="col-sm-4 col-12 edit-div">
                                <span>5 Records</span>

                                <button className="btn btn-edit" title="Trash">
                                    <i className="fa fa-trash-o"/>
                                </button>
                                <button type="primary" className="btn btn-edit">
                                    <i className="fa fa-eye"/>
                                </button>
                                <button type="primary" className={"btn btn-edit "}>
                                    <i className="icon-printer"/>
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="listing-table">
                                    <Table rowKey={row => row.id}
                                           className="responsive-table table table-hover waste-profile-tbl"
                                           columns={this.columns} loading={loading} dataSource={data}
                                           locale={{emptyText: 'No Waste Profile Available'}}/>
                                </div>
                            </div>
                        </div>
                        {this.state.AddWasteProfile && <AddWasteProfile id={editId} fetch={() => this.fetchWasteProfile()} visible={this.state.AddWasteProfile}
                                         onCancel={() => this.showAddWasteProfile(false)}/> }
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/tracks/waste_profile/WasteProfile.jsx